<div class="directCallChat panel" [class.stickyMode]="stickyMode" [class.dragging-file]="isDraggingFile"
  (dragenter)="onDragEnter($event)" (dragover)="onDragOver($event)" (dragleave)="onDragLeave($event)" (drop)="onDrop($event)">

  @if (!stickyMode) {
    <div class="close" (click)="closeChat()">
      <label class="close-icon">
        <i class="material-icons notranslate">close</i>
      </label>
    </div>
  }

  <div #messagesContainer class="messagesContainer" (scroll)="onScroll($event)">
    @if (loadingChat) {
      <div class="loading-spinner"></div>
    }

    <directCall-chat-message [chatMessage]="initialMessage"></directCall-chat-message>

    @for (messageGroup of group; track trackByGroup($index, messageGroup)) {
      <div class="divgroup">
        <div class="dateDivider">
          <div class="date">{{ messageGroup[0].date | date:'mediumDate' }}</div>
          <div class="line"></div>
        </div>
        @for (message of messageGroup; track trackByMessage($index, message)) {
          <div [attr.data-id]="message.id" class="divmessage">
            <directCall-chat-message [chatMessage]="message" (messageLoaded)="scrollDownFile('messageLoaded')"></directCall-chat-message>
            @if (showDividerNewMessages && message.id === lastChatMessageId) {
              <div id="newMessages" class="new-divider">
                <mat-divider></mat-divider>
                <span>Mensajes nuevos</span>
                <mat-divider></mat-divider>
              </div>
            }
          </div>
        }
      </div>
    }
  </div>

  <div class="newMessage">

    <div class="chat-input-actions">

      <button class="button-menu" matIconButton [matMenuTriggerFor]="actionsMenu" matTooltip="{{'TOOLTIP.MORE_OPTIONS' | translate}}">
        <mat-icon class="notranslate">add</mat-icon>
      </button>

      <mat-menu #actionsMenu="matMenu" class="dark-mode">
        <button mat-menu-item (click)="getChatSummary()">
          <div class="members-button">
            <div class="member-button-icon"><img id="sendChat" src="/assets/images/chat/generate-report.svg" class="chatSummaryButton"></div>
            <span>{{'CHAT_SUMMARY.TITLE' | translate}}</span>
          </div>
        </button>
        <button mat-menu-item>
          <div class="members-button" (click)="openFileDialog()">
            <div class="member-button-icon"><i class="material-icons notranslate">attach_file</i></div>
            <span>{{'TOOLTIP.ATTACH_FILE' | translate}}</span>
          </div>
        </button>
      </mat-menu>
    </div>

    <!--       <label class="file-input-icon icon2" (click)="takePhoto()" matTooltip="{{'TOOLTIP.TAKE_PHOTO' | translate}}">
    <i class="material-icons notranslate">add_a_photo</i>
  </label> -->

  <div class="file-input-icon icon1" [class.disabled]="!isMicAvailable" matTooltip="{{'TOOLTIP.RECORD_AUDIO' | translate}}">
    <label (click)="recordVoice()">
      @if (!isMicAvailable) {
        <i class="material-icons notranslate">mic_off</i>
      }
      @if (isMicAvailable && !isRecordingVoice) {
        <i class="material-icons notranslate">mic</i>
      }
      @if (isMicAvailable && isRecordingVoice) {
        <i class="material-icons notranslate blinking">stop</i>
      }
    </label>
  </div>

  <div class="file-input-icon icon2" matTooltip="{{'TOOLTIP.ADD_EMOJI' | translate}}">
    <label (click)="toggleEmojiPicker($event)"><i class="material-icons notranslate">mood</i></label>
  </div>

  @if (showEmojiPicker) {
    <div #emojiPicker class="emoji-container">
      <emoji-mart (emojiClick)="addEmoji($event)" data="emojiData" [showPreview]="false" set="google" [hideObsolete]="true"></emoji-mart>
    </div>
  }

  <input #fileInput id="fileInput" type="file" (change)="onFileSelected($event)" accept="image/*,video/*,application/pdf,audio/wav,application/zip">
  <div #textarea class="inputText" id="chatInput" contenteditable="true" (input)="onInput()" (keyup.enter)="addNewMessage()"></div>

  <img id="sendChat" src="/assets/images/chat/send.svg" class="sendButton" (click)="addNewMessage()">

</div>

@if (newMessage.chatFile?.file) {
  <div class="attachment-info">
    <p class="attachment-name">{{ newMessage.chatFile?.file?.name }} ({{ (newMessage.chatFile?.file?.size!/1000000).toFixed(0) }} MB)</p>
    <i (click)="clearAttachment()" class="material-icons notranslate">delete_outline</i>
  </div>
}

@if (attachment) {
  <div class="attachment-info">
    <p class="attachment-name">{{ attachment.size }}</p>
    <i (click)="clearAttachment()" class="material-icons notranslate">delete_outline</i>
  </div>
}

@if (loadingProgress > 0) {
  <div class="progress-container">
    <div class="progress-bar-container">
      <div class="progress-bar" [style.width.%]="loadingProgress"></div>
    </div>
    <span class="progress-text">{{ loadingProgress }}%</span>
  </div>
}

</div>
